/* eslint-disable */
// Environment-aware Cognito configuration.
// Selected at build time via REACT_APP_BUILD_ENV.

const envConfigs = {
  dev: {
    aws_user_pools_id: 'ap-southeast-2_xeOEMjFbt',
    aws_user_pools_web_client_id: '2c5ofphied3csletjaluae4hrr',
    oauth: {
      domain: 'auth.dev.liively.app',
      scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
      redirectSignIn: 'http://localhost:3000/sso-auth-success,https://patron.dev.liively.app/sso-auth-success,https://patron.dev.liive.ly/sso-auth-success',
      redirectSignOut: 'http://localhost:3000/logout,https://patron.dev.liively.app/logout,https://patron.dev.liive.ly/logout',
      responseType: 'code',
    },
  },
  stage: {
    aws_user_pools_id: 'ap-southeast-2_ujNQb6HAe',
    aws_user_pools_web_client_id: '7oon3tbknqgelv5ddkfqaos2nu',
    oauth: {
      domain: 'auth.stage.liive.ly',
      scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
      redirectSignIn: 'http://localhost:3000/sso-auth-success,https://patron.stage.liively.app/sso-auth-success,https://patron.stage.liive.ly/sso-auth-success',
      redirectSignOut: 'http://localhost:3000/logout,https://patron.stage.liively.app/logout,https://patron.stage.liive.ly/logout',
      responseType: 'code',
    },
  },
  prod: {
    aws_user_pools_id: 'ap-southeast-2_VmaefnXev',
    aws_user_pools_web_client_id: '58g5hprq16de2o74agiu1lljea',
    oauth: {
      domain: 'auth.prod.liively.app',
      scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
      redirectSignIn: 'http://localhost:3000/sso-auth-success,https://order.liively.app/sso-auth-success,https://order.liive.ly/sso-auth-success,https://order.prod.liively.app/sso-auth-success,https://order.prod.liive.ly/sso-auth-success',
      redirectSignOut: 'http://localhost:3000/logout,https://order.liively.app/logout,https://order.liive.ly/logout,https://order.prod.liively.app/logout,https://order.prod.liive.ly/logout',
      responseType: 'code',
    },
  },
};

const env = process.env.REACT_APP_BUILD_ENV || 'dev';
const config = envConfigs[env] || envConfigs['dev'];

const awsmobile = {
  aws_project_region: 'ap-southeast-2',
  aws_cognito_region: 'ap-southeast-2',
  ...config,
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['GOOGLE', 'APPLE'],
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_signup_attributes: [],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: ['REQUIRES_LOWERCASE', 'REQUIRES_NUMBERS'],
  },
  aws_cognito_verification_mechanisms: ['EMAIL', 'PHONE_NUMBER'],
};

export default awsmobile;
